import { RangoSalarialPerfil } from './rango-salarial-perfil.interface';
import {
  RangoSalarialPerfilDto,
  CreateRangoSalarialPerfilDto,
  UpdateRangoSalarialPerfilDto
} from './rango-salarial-perfil.dto';

export class RangoSalarialPerfilMapper {
  static fromDto(dto: RangoSalarialPerfilDto): RangoSalarialPerfil {
    return {
      rangoSalarialId: dto.rango_Salarial_ID,
      perfilId: dto.perfil_ID,
      ano: dto.año,
      minimo: dto.minimo,
      maximo: dto.maximo,
      perfilNombre: dto.nombrePerfil || undefined
    };
  }

  static fromDtoList(dtoList: RangoSalarialPerfilDto[]): RangoSalarialPerfil[] {
    return dtoList.map(dto => this.fromDto(dto));
  }

  static toCreateDto(
    perfilId: number,
    ano: number,
    minimo: number,
    maximo: number
  ): CreateRangoSalarialPerfilDto {
    return {
      perfil_ID: perfilId,
      año: ano,
      minimo: minimo,
      maximo: maximo
    };
  }

  static toUpdateDto(
    id: number,
    perfilId: number,
    ano: number,
    minimo: number,
    maximo: number
  ): UpdateRangoSalarialPerfilDto {
    return {
      Rango_Salarial_ID: id,
      Perfil_ID: perfilId,
      Año: ano,
      Minimo: minimo,
      Maximo: maximo
    };
  }
}
